let svgNodeCache = {};
export function resetSvgNodeCache() {
    svgNodeCache = {};
}
export default svgNodeCache;
//# sourceMappingURL=svgNodeCache.js.map